import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-box-checked-focus",
  "use": "check-box-checked-focus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"check-box-checked-focus\"><path fill-rule=\"evenodd\" d=\"M19 5v14H5V5h14Zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM6.5 12.17l1.41-1.41 2.59 2.58 5.59-5.59 1.41 1.42-7 7-4-4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol